import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountantInfoComponent } from './accountant-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [AccountantInfoComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
  ],
  exports: [AccountantInfoComponent],
})
export class AccountantInfoModule { }
